// Stocks & commodity ETFs — Parqet logo CDN (free, no key)
const EQUITY_AND_ETF = new Set([
  "TSLA",
  "AAPL",
  "NVDA",
  "META",
  "GOOGL",
  "GOOG",
  "AMZN",
  "MSFT",
  "AMD",
  "PLTR",
  "COIN",
  "MSTR",
  "INTC",
  "NFLX",
  "GME",
  "AMC",
  "SNAP",
  "UBER",
  "BABA",
  "NIO",
  "RIVN",
  "ABNB",
  "HOOD",
  "SHOP",
  "SQ",
  "PYPL",
  "RBLX",
  "DKNG",
  "ARM",
  "SMCI",
  "SPY",
  "QQQ",
  "IWM",
  "GLD",
  "SLV",
  "USO",
  "GDX",
  "ARKK",
]);

// Raw commodities / indices — no tradeable logo
const NO_ICON = new Set([
  "SPX",
  "NDX",
  "NIKKEI",
  "FTSE",
  "DAX",
  "RUT",
  "XAU",
  "XAG",
  "XPT",
  "XPD",
  "WTI",
  "BRENT",
  "NATGAS",
]);

// k-prefixed HL micro-denomination tokens — strip 'k', use base icon
const K_PREFIXED = new Set([
  "KBONK",
  "KPEPE",
  "KSHIB",
  "KDOGE",
  "KFLOKI",
  "KNEIRO",
  "KLUNC",
]);

// CoinGecko overrides for newer / ambiguous crypto
const CG_OVERRIDES: Record<string, string> = {
  HYPE: "https://assets.coingecko.com/coins/images/35876/thumb/hyperliquid.png",
  PURR: "https://assets.coingecko.com/coins/images/38521/thumb/purr.png",
  W: "https://assets.coingecko.com/coins/images/35087/thumb/wormhole.png",
  IO: "https://assets.coingecko.com/coins/images/35852/thumb/io_net_logo.png",
  ZK: "https://assets.coingecko.com/coins/images/31049/thumb/zksync.png",
  EIGEN: "https://assets.coingecko.com/coins/images/37285/thumb/eigen_logo.png",
  ZRO: "https://assets.coingecko.com/coins/images/34058/thumb/zro.png",
  ENA: "https://assets.coingecko.com/coins/images/36530/thumb/ethena.png",
  NOT: "https://assets.coingecko.com/coins/images/35116/thumb/notcoin.jpg",
  ONDO: "https://assets.coingecko.com/coins/images/26580/thumb/ONDO.png",
  NEIRO: "https://assets.coingecko.com/coins/images/39382/thumb/neiro.jpg",
  GOAT: "https://assets.coingecko.com/coins/images/41074/thumb/goat.png",
  PNUT: "https://assets.coingecko.com/coins/images/41284/thumb/peanut.png",
};

/** Returns URLs to try in order. Empty array = show initials only. */
export function getIconUrls(symbol: string): string[] {
  const s = symbol.trim().toUpperCase();
  if (!s) return [];
  if (NO_ICON.has(s)) return [];
  if (EQUITY_AND_ETF.has(s))
    return [`https://assets.parqet.com/logos/symbol/${s}?format=png`];
  if (K_PREFIXED.has(s)) {
    const base = s.slice(1).toLowerCase();
    return [`https://assets.coincap.io/assets/icons/${base}@2x.png`];
  }
  const urls: string[] = [];
  if (CG_OVERRIDES[s]) urls.push(CG_OVERRIDES[s]);
  urls.push(`https://assets.coincap.io/assets/icons/${s.toLowerCase()}@2x.png`);
  return urls;
}
